export const getPageModalBackgroundList = (data) => {
  return data?.map(({ id, name }) => ({ id, name }));
};
